import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ThemeStateService } from '@sites/site-theme/src/state';
import type { CurrentPageFormGroup } from '@web/widgets/catalog-products/type';
import { type PagesButtonsFormType } from '@web/widgets/catalog-products/type';
import type { ColorPickerEventPayload } from '@components/sp-color-picker/src/types/color-picker.type';
import { CommonModule } from '@angular/common';
import { CommonElementsModule } from '@web/widgets/common/common-elements.module';

@Component({
    selector: 'web-current-page-settings',
    templateUrl: './current-page-settings.component.html',
    styleUrls: ['./current-page-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, CommonElementsModule],
})
export class CurrentPageSettingsComponent {
    @Input() currentPageFormGroup: CurrentPageFormGroup;

    private readonly themeState = inject(ThemeStateService);

    public readonly selectedThemeColors = this.themeState.selectedColors;

    public get textColor(): PagesButtonsFormType['textColor'] {
        return this.currentPageFormGroup.get('textColor') as PagesButtonsFormType['textColor'];
    }

    public get backgroundColor(): PagesButtonsFormType['backgroundColor'] {
        return this.currentPageFormGroup.get('backgroundColor') as PagesButtonsFormType['backgroundColor'];
    }

    public get borderColor(): PagesButtonsFormType['borderColor'] {
        return this.currentPageFormGroup.get('borderColor') as PagesButtonsFormType['borderColor'];
    }

    public setThemeBackgroundColor({ value, presetName }: ColorPickerEventPayload): void {
        this.currentPageFormGroup.markAsTouched({ onlySelf: true });

        this.backgroundColor.patchValue(presetName ?? value);
    }

    public setBorderColor({ value, presetName }: ColorPickerEventPayload): void {
        this.currentPageFormGroup.markAsTouched({ onlySelf: true });

        this.borderColor.patchValue(presetName ?? value);
    }

    public setTextColor({ value, presetName }: ColorPickerEventPayload): void {
        this.currentPageFormGroup.markAsTouched({ onlySelf: true });

        this.textColor.patchValue(presetName ?? value);
    }
}
